import React, { useState, useMemo } from "react";

// create context
export const SidebarContext = React.createContext();

export const SidebarProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarMini, setIsSidebarMini] = useState(
    () => localStorage.getItem("im_sidebar_mini") === "true"
  );

  function toggleSidebar() {
    setIsSidebarOpen(!isSidebarOpen);
  }

  function closeSidebar() {
    setIsSidebarOpen(false);
  }

  function toggleSidebarMini() {
    setIsSidebarMini((prev) => {
      const newVal = !prev;
      localStorage.setItem("im_sidebar_mini", String(newVal));
      return newVal;
    });
  }

  const value = useMemo(
    () => ({
      isSidebarOpen,
      isSidebarMini,
      toggleSidebar,
      closeSidebar,
      toggleSidebarMini,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isSidebarOpen, isSidebarMini]
  );

  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
};
